export const IDLE_POLLS_BEFORE_SUSPEND = 18;

const LEGACY_COLLAB_PREFIX = 'b2b-order-collab-mode:';
const PREF_PREFIX = 'b2b-order-collab-pref:';
const SUSPENDED_PREFIX = 'b2b-order-collab-suspended:';

export const normalizeCollabLogin = (login: string | null | undefined) => {
    if (!login || !login.trim()) {
        return '_anonymous';
    }
    return login.trim().toLowerCase();
};

export const collabPrefStorageKey = (login: string | null | undefined, orderId: number) =>
    `${PREF_PREFIX}${normalizeCollabLogin(login)}:${orderId}`;

export const collabSuspendedStorageKey = (login: string | null | undefined, orderId: number) =>
    `${SUSPENDED_PREFIX}${normalizeCollabLogin(login)}:${orderId}`;

const legacyCollabStorageKey = (orderId: number) => `${LEGACY_COLLAB_PREFIX}${orderId}`;

const migrateLegacyPreference = (login: string | null | undefined, orderId: number) => {
    const legacyKey = legacyCollabStorageKey(orderId);
    if (localStorage.getItem(legacyKey) !== '1') {
        return;
    }

    localStorage.setItem(collabPrefStorageKey(login, orderId), '1');
    localStorage.removeItem(legacyKey);
};

export const hasCollabPreference = (login: string | null | undefined, orderId: number) => {
    migrateLegacyPreference(login, orderId);
    return localStorage.getItem(collabPrefStorageKey(login, orderId)) === '1';
};

export const isCollabSuspended = (login: string | null | undefined, orderId: number) =>
    localStorage.getItem(collabSuspendedStorageKey(login, orderId)) === '1';

export const isCollabActive = (login: string | null | undefined, orderId: number | null) =>
    !!orderId && hasCollabPreference(login, orderId) && !isCollabSuspended(login, orderId);

export const setCollabPreference = (login: string | null | undefined, orderId: number, enabled: boolean) => {
    migrateLegacyPreference(login, orderId);

    const prefKey = collabPrefStorageKey(login, orderId);
    const suspendedKey = collabSuspendedStorageKey(login, orderId);

    if (enabled) {
        localStorage.setItem(prefKey, '1');
        localStorage.removeItem(suspendedKey);
        localStorage.removeItem(legacyCollabStorageKey(orderId));
        return;
    }

    localStorage.removeItem(prefKey);
    localStorage.removeItem(suspendedKey);
    localStorage.removeItem(legacyCollabStorageKey(orderId));
};

export const suspendCollab = (login: string | null | undefined, orderId: number) => {
    if (!hasCollabPreference(login, orderId)) {
        return false;
    }

    localStorage.setItem(collabSuspendedStorageKey(login, orderId), '1');
    return true;
};

export const activateCollab = (login: string | null | undefined, orderId: number) => {
    if (!hasCollabPreference(login, orderId)) {
        return false;
    }

    localStorage.removeItem(collabSuspendedStorageKey(login, orderId));
    return true;
};

export const clearAllCollabStorageKeys = () => {
    const keysToRemove: string[] = [];

    for (let index = 0; index < localStorage.length; index++) {
        const key = localStorage.key(index);
        if (
            key &&
            (key.indexOf(LEGACY_COLLAB_PREFIX) === 0 ||
                key.indexOf(PREF_PREFIX) === 0 ||
                key.indexOf(SUSPENDED_PREFIX) === 0)
        ) {
            keysToRemove.push(key);
        }
    }

    keysToRemove.forEach((key) => localStorage.removeItem(key));
};
